module.exports = __webpack_public_path__ + "static/img/4813_phase_function_Paper_PointsHejduk_Prediction.0fbc11b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4813_phase_function_Paper_PointsHejduk_Prediction.png
// module id = nY7s
// module chunks = 0